import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAdminAuth } from "../../auth/AdminAuthProvider";
import { BASE_URL } from "../../../env";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { InputGroup, FormControl } from "react-bootstrap";
import { IoSearch } from "react-icons/io5";

const DisbursedMemberDetail = () => {
  const { adminUser } = useAdminAuth();
  const [disbursedLoanDetails, setDisbursedLoanDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 1000);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  useEffect(() => {
    fetchDisbursedLoanDetails();
  }, [adminUser]);

  const fetchDisbursedLoanDetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/disbursedmemberlist`);
      setDisbursedLoanDetails(response.data.data);
    } catch (error) {
      console.error(
        "Error fetching disbursed loan details:",
        error.response?.data
      );
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredMembers = disbursedLoanDetails.filter((member) => {
    const searchFields = [
      member.Division,
      member.BranchName,
      member.FundingAgency,
      member.Product,
      member.Tenure,
      member.VTC,
      member.MemberID,
      member.MemberName,
      member.AadhaarNumber,
      member.LANNumber,
      member.GTLanNumber,
      member.ENachName,
      member.MobileNumber,
      member.LoanDate,
      member.LoanAmount,
      member.SBAccountNumber,
      member.HouseNumber,
      member.Street,
      member.Locality,
      member.State,
      member.PINCode,
      member.ECSDate,
      member.EmiStartDate,
      member.EmiEndDate,
      member.EmiAmount,
      member.EcsBankName,
      member.EcsName,
      member.IfscCode,
      member.EscAccNo,
      member.BankLinkedMobileNumber,
    ];

    return searchFields.some((field) =>
      field?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMembers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container">
          <div className="master-search-section">
            <h1 className="TableHeaderText w-100 text-start">Disbursed Member Details</h1>
            <div className="search-input-wrapper" style={{ minWidth: "300px" }}>
              <span className="search-icon">
                <IoSearch color="#666" />
              </span>
              <input
                type="text"
                placeholder="Search across all fields..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="search-input"
              />
            </div>
          </div>

          <div className="master-list-section">
            <div className="master-table-wrapper table-responsive p-0" style={{ padding: "0 15px" }}>
              <table className="table table-hover align-middle mb-0 table-list">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Division</th>
                    <th>Branch</th>
                    <th>Funding Agency</th>
                    <th>Product</th>
                    <th>Tenure</th>
                    <th>VTC</th>
                    <th>Member ID</th>
                    <th>Member Name</th>
                    <th>Aadhaar</th>
                    <th>LAN</th>
                    <th>GT LAN</th>
                    <th>Mobile</th>
                    <th>Loan Date</th>
                    <th>Amount</th>
                    <th>EMI Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((member, index) => (
                      <tr key={index}>
                        <td className="fw-bold text-muted">{indexOfFirstItem + index + 1}</td>
                        <td>{member.Division || "N/A"}</td>
                        <td>{member.BranchName || "N/A"}</td>
                        <td>{member.FundingAgency || "N/A"}</td>
                        <td>{member.Product || "N/A"}</td>
                        <td>{member.Tenure || "N/A"}</td>
                        <td>{member.VTC || "N/A"}</td>
                        <td>{member.MemberID || "N/A"}</td>
                        <td className="fw-bold">{member.MemberName || "N/A"}</td>
                        <td>{member.AadhaarNumber || "N/A"}</td>
                        <td>{member.LANNumber || "N/A"}</td>
                        <td>{member.GTLanNumber || "N/A"}</td>
                        <td>{member.MobileNumber || "N/A"}</td>
                        <td>{member.LoanDate || "N/A"}</td>
                        <td className="text-success fw-bold">₹{member.LoanAmount || "0"}</td>
                        <td>₹{member.EmiAmount || "0"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="16" className="text-center py-5 text-muted">
                        No members found matching your search.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="master-pagination-wrapper">
                <div className="d-flex justify-content-between align-items-center w-100 p-3 flex-wrap gap-2">
                  <span className="small">Total Records: {filteredMembers.length}</span>
                  <ul className="pagination pagination-sm mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                    </li>
                    <li className="page-item active">
                      <span className="page-link px-3">Page {currentPage} of {totalPages}</span>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DisbursedMemberDetail;
